import React, { useState, useEffect } from "react";
import * as Icon from "react-bootstrap-icons";

const CartLine = ({
  product,
  handleQuantityChange,
  addToCart,
  removeFromCart,
  total,
}) => {
  const [isLoading, setIsLoading] = useState(true); // Loading state

  useEffect(() => {
    // Ensure all necessary product fields are available before loading the product
    if (product?.product?.title && product?.product?.image) {
      setIsLoading(false); // When product data is fully loaded, set loading to false
    } else {
      setIsLoading(true); // Keep loading state true if product is undefined or incomplete
    }
  }, [product]);

  if (isLoading) {
    return (
      <div className="card">
        <div className="row p-3">
          <div className="col-md-12 d-flex justify-content-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="row p-3">
        <div className="col-md-2">
          <img
            src={
              product?.product?.image?.length > 0
                ? `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_product_IMAGE_URL}${product.product.image[0]}`
                : "https://upload.wikimedia.org/wikipedia/commons/9/92/No_Preview_1.jpg"
            }
            className="img-fluid rounded-start"
            alt={
              product?.product?.image?.length > 0
                ? product.product.image[0]
                : "No image available"
            }
          />
        </div>
        <div className="col-md-10">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-8 col-6 mb-lg-0 mb-md-2 mb-2">
                <h5 className="card-title">{product.product.title}</h5>
              </div>
              <div className="col-lg-4 col-6 cart-line-amount">
                {/* <h5>₹ {product.product.price}</h5> */}
                <h5>₹ {product.product.update_price}</h5>
              </div>
            </div>
            <div className="mb-2">
              <p className="card-text text-muted sku">
                SKU - {product.product.sku}
              </p>
            </div>
            <div className="mt-3 d-flex justify-content-between align-items-center">
              <div className="d-flex">
                {/* Decrease Quantity Button */}
                <button
                  className="btn btn-outline-secondary"
                  disabled={
                    product.quantity <= 1 ||
                    product.quantity <= product.product.minimumOrderQty
                  }
                  onClick={() =>
                    handleQuantityChange(
                      product.product.id,
                      product.quantity - 1
                    )
                  }
                >
                  -
                </button>

                {/* Quantity Input */}
                <input
                  type="number"
                  min={1}
                  max={product.product.stockQty || 25} // Use correct stock limit
                  value={product.quantity}
                  className="form-control shadow-none mx-2 cart-quantity"
                  onChange={(e) =>
                    handleQuantityChange(
                      product.product.id,
                      parseInt(e.target.value) || 1
                    )
                  }
                />

                {/* Increase Quantity Button */}
                <button
                  className="btn btn-outline-secondary"
                  onClick={() =>
                    handleQuantityChange(
                      product.product.id,
                      product.quantity + 1
                    )
                  }
                  disabled={product.quantity >= product.product.stockQty}
                >
                  +
                </button>
              </div>

              <button
                onClick={() => removeFromCart(product.product.id)}
                className="btn border-0"
              >
                <Icon.Trash3 color="#ff0000"></Icon.Trash3>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartLine;
